import React from 'react';
import { X, ArrowLeft } from '@phosphor-icons/react';

// Desktop right-pane wrapper used instead of the full-page layout
export const DetailPaneShell = ({ title, onClose, onBack, backLabel, rightAction, children }) => (
  <div className="bg-white/70 rounded-2xl border border-gray-200 shadow-sm" data-testid="detail-pane">
    <div className="sticky top-0 z-10 flex items-center justify-between gap-3 px-5 py-3 bg-white border-b border-gray-200 rounded-t-2xl">
      <div className="flex items-center gap-2 min-w-0">
        {onBack && (
          <button
            onClick={onBack}
            data-testid="detail-pane-back-btn"
            className="flex items-center gap-1 text-sm font-medium text-blue-600 hover:text-blue-800 px-2 py-1 rounded-lg hover:bg-blue-50 transition-colors"
          >
            <ArrowLeft size={16} weight="bold" />
            <span className="truncate max-w-[10rem]">{backLabel}</span>
          </button>
        )}
        <h2 className="font-display text-base font-semibold text-gray-900 truncate">{title}</h2>
      </div>
      <div className="flex items-center gap-1">
        {rightAction}
        <button
          onClick={onClose}
          data-testid="detail-pane-close-btn"
          aria-label="Close"
          className="p-1.5 rounded-lg text-gray-500 hover:text-gray-900 hover:bg-gray-100 transition-colors"
        >
          <X size={18} weight="bold" />
        </button>
      </div>
    </div>
    <div className="p-5">{children}</div>
  </div>
);

export default DetailPaneShell;
